import { useMemo, useState } from "react";

const Field = ({ label, value, min, max, step, unit, onChange, format, testid }) => (
  <div className="py-7 border-b border-white/10">
    <div className="flex items-baseline justify-between mb-5">
      <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#a7a7a2]">{label}</span>
      <span className="display text-2xl sm:text-3xl text-[#f5f3ee]">
        {format ? format(value) : value}
        <span className="text-[#5c5c58] text-base ml-1 font-mono">{unit}</span>
      </span>
    </div>
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      data-testid={testid}
      className="w-full appearance-none bg-transparent cursor-pointer accent-[#5CCBF5]
        [&::-webkit-slider-runnable-track]:h-px [&::-webkit-slider-runnable-track]:bg-white/20
        [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4
        [&::-webkit-slider-thumb]:-mt-2 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-[#5CCBF5]
        [&::-moz-range-track]:h-px [&::-moz-range-track]:bg-white/20
        [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-[#5CCBF5]"
    />
  </div>
);

const money = (n) => `$${n.toLocaleString()}`;

export const CapacityCalculator = () => {
  const [rate, setRate] = useState(150);
  const [hours, setHours] = useState(15);
  const [weeks, setWeeks] = useState(48);

  const annual = useMemo(() => rate * hours * weeks, [rate, hours, weeks]);

  return (
    <div className="grid gap-10 lg:grid-cols-[1fr_0.9fr] lg:gap-16" data-testid="capacity-calculator">
      <div>
        <Field label="Your hourly value" value={rate} min={50} max={300} step={10} unit="/hr" format={money} onChange={setRate} testid="calc-rate" />
        <Field label="Hours a week on repetitive tasks" value={hours} min={0} max={40} step={1} unit="hrs" onChange={setHours} testid="calc-hours" />
        <Field label="Working weeks / year" value={weeks} min={30} max={52} step={1} unit="wks" onChange={setWeeks} testid="calc-weeks" />
      </div>

      <div className="flex flex-col justify-center border border-white/10 bg-[#131C31] p-10">
        <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-[#5CCBF5] mb-6">
          Potential Annual Leakage
        </p>
        <p className="display text-5xl sm:text-6xl lg:text-7xl text-[#f5f3ee] tabular-nums" data-testid="calc-output">
          {money(annual)}
        </p>
        <div className="mt-8 h-px bg-white/10" />
        <p className="mt-6 text-[#a7a7a2] text-sm leading-relaxed">
          {rate.toLocaleString()} × {hours} hrs × {weeks} weeks. Illustrative calculation — not a guaranteed number, just a gut check.
        </p>
      </div>
    </div>
  );
};

export default CapacityCalculator;
